import { useDispatch } from "react-redux";

import { PanelType } from "models/panel";
import { IPolicyPanelInfo, PolicyEditState } from "models/policyPanel";
import { panelActions } from "store/panelSlice";
import { useTrackingContext } from "components/shared/TrackingContext";

const usePolicyPanel = () => {
  const dispatch = useDispatch();
  const { trackEvent } = useTrackingContext();

  const clearPanel = () => {
    // TODO: Clear policy forms when we implement them
    // dispatch(policyFormsActions.clear());
  };

  const updatePanel = (policyPanelInfo: IPolicyPanelInfo) => {
    dispatch(
      panelActions.setPanel({
        panelType: PanelType.Policy,
        agreementObjectIds: {
          policyId: policyPanelInfo.policyId,
        },
        additionalInfo: {
          policyEditState: policyPanelInfo.editState,
        },
      })
    );
  };

  const openPanel = (
    policyId: string | undefined,
    editState?: PolicyEditState
  ) => {
    clearPanel();
    trackEvent(`Policy ${editState || 'edit '} panel opens`);
    const panelInfo = {
      policyId,
      editState: editState || PolicyEditState.Default,
    };
    updatePanel(panelInfo);
  };

  const closePanel = () => {
    clearPanel();
    dispatch(panelActions.closePanel());
  };

  return { 
    clearPanel,
    updatePanel, 
    openPanel, 
    closePanel 
  };
};

export default usePolicyPanel;